import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Container } from '@mui/material';
import LoginPage from './pages/LoginPage';
import AuthCallback from './pages/auth/AuthCallback';
import SilentRenew from './pages/auth/SilentRenew';
import PrivateRoute from './routes/PrivateRoute';
import { AppShell } from './layouts/AppShell';
import DashboardPage from './pages/DashboardPage';
import DatabaseExplorerPage from './pages/DatabaseExplorerPage';
import EasyflexSyncPage from './pages/EasyflexSyncPage';
import OpenApiExplorerPage from './pages/OpenApiExplorerPage';
import DocumentApprovalsPage from './pages/DocumentApprovalsPage';
import UserEngagementPage from './pages/UserEngagementPage';
import AiObservabilityPage from './pages/AiObservabilityPage';

const App: React.FC = () => {
  return (
    <Container disableGutters maxWidth={false} sx={{ minHeight: '100vh', p: 0 }}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/auth/silent-renew" element={<SilentRenew />} />

        <Route
          path="/"
          element={
            <PrivateRoute>
              <AppShell />
            </PrivateRoute>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="easyflex" element={<EasyflexSyncPage />} />
          <Route path="db" element={<DatabaseExplorerPage />} />
          <Route path="api" element={<OpenApiExplorerPage />} />
          <Route path="approvals" element={<DocumentApprovalsPage />} />
          <Route path="engagement" element={<UserEngagementPage />} />
          <Route path="ai-observability" element={<AiObservabilityPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Container>
  );
};

export default App;
